'use strict';
import LazyLoad from "vanilla-lazyload";

// ES6 class definition
export default class Bvi {

  constructor() {
    let self = this;
  }

  go(debugMode = false) {

    let self = this;
    self.addLazyLoading();
    self.addObjectFitPolyfill();

    // active main menu
    if (document.getElementById('menu')) {
      document.getElementById('menu').style.display = 'flex';
    }

  }

  /**
   * init lazy loading
   */

  addLazyLoading() {
    let self = this;

    let myLazyMember = new LazyLoad({
      elements_selector: ".lazy-member"
    });

    let myLazyLoad = new LazyLoad({
      elements_selector: ".lazy",
      load_delay: 500,
      // Assign the callbacks defined
      callback_reveal: self.callback_reveal
    });
  }

  /**
   * Add Object-Fit polyfills for IE
   */
  addObjectFitPolyfill() {
    let self = this;

    if (self.detectIE()) {
      $('.teaser__figure, .hero__figure, .image-fit').each(function () {
        let container = $(this);
        let imgUrl = container.find('img').prop('src');

        let sources = $(this).find('source');

        // TODO make this dynamic and select matching source
        sources.each(function () {
          if ($(this).attr('media') == '(min-width: 1024px)') {

            if ($(this).attr('data-srcset')) {
              imgUrl = $(this).attr('data-srcset');
            } else {
              imgUrl = $(this).attr('srcset');
            }

          }
        });

        if (imgUrl) {
          container.css('backgroundImage', 'url(' + imgUrl + ')').
          addClass('compat-object-fit');
        }
      });
    }
  }

  /**
   * Detect IE
   *
   * @return {*}
   */
  detectIE() {
    let ua = window.navigator.userAgent;

    // Test values; Uncomment to check result …

    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

    // Edge 12 (Spartan)
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

    // Edge 13
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

    let msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    let trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      let rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    let edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
  }

  callback_reveal(element) {
    element.classList.add('revealed');
  }

}
